import { ChatTeardropText } from "@phosphor-icons/react";
import { formatDateTimeBs } from "@/lib/format";
import { Panel } from "./detail/Panel";
import type { EnrollmentQuestionnaireResponse } from "@/types/enrollment-questionnaire";

interface Props {
  response: EnrollmentQuestionnaireResponse | null | undefined;
}

export function TherapistQuestionnaireSection({ response }: Props) {
  return (
    <Panel
      title="Enrollment upitnik"
      count={response?.snapshotQuestions.length}
      action={
        response ? (
          <span className="text-[11px] tabular-nums text-muted-foreground">
            {formatDateTimeBs(response.submittedAt)}
          </span>
        ) : null
      }
    >
      {!response ? (
        <div className="flex items-center gap-3 rounded-lg border border-dashed border-border/70 px-3 py-4 text-sm text-muted-foreground">
          <ChatTeardropText className="size-5 shrink-0 text-muted-foreground/40" />
          <span>Terapeut nije popunio upitnik, registrovan je prije njegovog uvođenja.</span>
        </div>
      ) : (
        <dl className="divide-y divide-border/50">
          {response.snapshotQuestions.map((q, idx) => {
            const answer = response.answers[q.id];
            return (
              <div key={q.id} className="grid grid-cols-[1.5rem_1fr] gap-x-3 py-3 first:pt-0 last:pb-0">
                <span
                  aria-hidden
                  className="pt-0.5 text-xs font-semibold tabular-nums text-muted-foreground/50"
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0">
                  <dt className="text-sm font-medium leading-snug text-foreground">
                    {q.prompt}
                  </dt>
                  <dd className="mt-1 whitespace-pre-wrap text-sm leading-relaxed text-muted-foreground">
                    {answer && answer.trim().length > 0 ? (
                      answer
                    ) : (
                      <span className="text-muted-foreground/50">nema odgovora</span>
                    )}
                  </dd>
                </div>
              </div>
            );
          })}
        </dl>
      )}
    </Panel>
  );
}
